import breakpoints from 'base/constants/breakpoints';
import styled from 'styled-components';
import { Button, colors } from 'syngenta-digital-cropwise-react-ui-kit';

export const ReportOverviewWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: 24px 64px;
`;

export const ReportOverviewSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  margin-top: 15px;
  margin-bottom: 40px;
  gap: 16px;
  border-radius: 16px;
  border: 2px solid var(--Neutral-neutral-30, #c2c7d0);
  background: #232630;
  backdrop-filter: blur(5px);
  color: #fff;
`;

export const IconBox = styled.span`
  border-radius: 6px;
  background: rgba(105, 111, 136, 0.5);
  display: flex;
  width: 24px;
  height: 24px;
  padding: 6.75px 4.836px 4.25px 4.164px;
  justify-content: center;
  align-items: center;

  .icon-size {
    width: 16px;
    height: 16px;
  }
`;

export const StyledHeaderText = styled.span`
  font-family: 'Noto Sans';
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: -0.375px;
  text-align: left;
`;

export const StyledHeaderSmallText = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.15px;
  text-align: left;
`;

export const StyledHeaderVerySmallText = styled.span`
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.12px;
  text-align: left;
  white-space: pre-line;

  &::after {
    content: ' ';
  }
`;
export const StyledSummaryGenerationText = styled.div`
  display: flex;
  align-items: center;
  padding-left: 2px;
  gap: 10px;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
  text-align: left;
`;

export const StyledAISummaryDeclarationText = styled.div`
  text-align: right;
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
`;
export const StyledAISummaryWarningText = styled.div`
  text-align: right;
  font-family: 'Noto Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.09px;
`;

export const StyledSummaryFeedbackContainer = styled.div`
  display: flex;
  gap: 16px;

  @media screen and ${breakpoints.maxWidth.sm} {
    gap: 6px;
  }
`;

export const StyledSummaryFeedbackText = styled.div`
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.12px;
`;

export const StyledFeedbackButton = styled(Button)`
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px transparent;
  border-radius: 50%;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);

  &:hover {
    border: none;
    background-color: ${colors.neutral30};
  }
`;
